import dragDerp from '@scoutgg/ftw/source/services/drag-and-derp'
import dragImage from '@scoutgg/ftw/source/services/drag-with-image'
import normalize from '../../helpers/normalize'

function collapse(sources) {
  sources.forEach((s, i) => {
    s.priority = i + 1
  })
}

export function attached(component, model) {
  dragImage
    .call(dragDerp(`sporty-card`, component))
    .on('drag', dragging => {
      dragging.source = dragging.target.obj
      dragging.source.$isDragged = true
      component.render()
    })
    .on('end', dragging => {
      delete dragging.source.$isDragged
      dragging.source.$changed = true
      component.render()
    })
  dragDerp('.entry, .new-entries, .unassigned', component)
    .on('enter', dragging => {
      dragging.target.classList.add('hovered')
    })
    .on('leave', dragging => {
      dragging.target.classList.remove('hovered')
    })
  dragDerp(`[data-${model}`, component).on('drop', ({source, target}) => {
    source.priority = Infinity
    if(source[model]) collapse(component.sources(source[model]))
    source.priority = Infinity
    source[model] = target.dataset[model]
    collapse(component.sources(source[model]))
    delete source.$new
    component.$cached = null
    if(component.sourcesByModel) {
      const sources = component.sourcesByModel
      const key = source[model]
      if(!sources[key]) sources[key] = []
      if(!sources[key].includes(source)) sources[key].push(source)
    }
    if(!source.priority || (source.priority === Infinity)) source.priority = 1
    component.render()
  })
  dragDerp('.new-entries', component).on('drop', ({source}) => {
    var instance = source[model]
    if(component.sourcesByModel && source[model]) {
      const arr = component.sourcesByModel[source[model]]
      if(arr) {
        const index = arr.indexOf(source)
        if(~index) arr.splice(index, 1)
      }
    }
    source[model] = null
    if(instance) collapse(component.sources(instance))
    source[model] = null
    source.$new = true
    component.$cached = null
    component.render()
  })
  dragDerp('.unassigned', component).on('drop', ({source}) => {
    var instance = source[model]
    if(component.sourcesByModel && source[model]) {
      const arr = component.sourcesByModel[source[model]]
      if(arr) {
        const index = arr.indexOf(source)
        if(~index) arr.splice(index, 1)
      }
    }
    source[model] = null
    if(instance) collapse(component.sources(instance))
    source[model] = null
    delete source.$new
    component.$cached = null
    component.render()
  })
}

function hashMap({models, hash}) {
  return (models || []).reduce((obj, model) => {
    obj[hash(model)] = model
    return obj
  }, {})
}

function count({sources, attribute, hash}) {
  return (sources || []).reduce((obj, s) => {
    if(!s[attribute]) return obj
    var key = hash ? hash(s[attribute]) : s[attribute]
    obj[key]
      ? obj[key]++
      : obj[key] = 1
    return obj
  }, {})
}

export function autoAssign({attribute, sources, models, hash, seasonSource}) {
  var map = hashMap({models, hash})
  var counts = count({sources, attribute, hash})
  nonSources({attribute, sources, seasonSource}).forEach(source => {
    var key = hash(source)
    source[attribute] = map[key]
    source.$changed = true
    if(!source[attribute]) return
    source.priority = counts[key]
      ? ++counts[key]
      : counts[key] = 1
  })

}

export function nonSources({attribute, sources, seasonSource, gender, country}) {
  return (sources || [])
    .filter(s => !seasonSource || s.seasonSource === seasonSource)
    .filter(s => !gender || gender === '' || s.gender === gender)
    .filter(s => !country || country === '' || s.country === country)
    .filter(s => !s[attribute] && !s.$new)
}

export function sortedModels(opts) {
  var search = (opts.search || '').split(',')
    .map(part => isNaN(part) ? normalize(part) : part)
    .filter(part => part)
  var counts = count({sources: opts.sources, attribute: `${opts.attribute}Id`})
  return (opts.models || [])
    .filter(m => (counts[m._id] || 0) <= (opts.sourceCount || Infinity))
    .filter(m => {
      if(!search.length || !opts.match) return true
      return search.length === search.filter(s => opts.match(m, s)).length
    })
    .sort(opts.sort || ((a, b) => a._id.localeCompare(b._id)))
}

export function cacheModels(component, model) {
  const sourcesByModel = {}
  for(const source of component[model + 'Sources']) {
    const instance = source[model]
    if(!instance) continue
    if(!sourcesByModel[instance]) sourcesByModel[instance] = []
    const sources = sourcesByModel[instance]
    sources.push(source)
    if(sources.length < 2) continue
    sources.sort((a, b) => a.priority - b.priority)
  }
  const customByModel = {}
  for(const source of component.customSources) {
    customByModel[source[model]] = source
  }
  component.sourcesByModel = sourcesByModel
  component.customByModel = customByModel
}

export default {
  attached,
  autoAssign,
  nonSources,
  sortedModels,
  cacheModels,
}
